import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Field } from 'src/app/base/interfaces/field';

@Component({
    selector: '[app-easysuite-password]',
    templateUrl: './easysuite-password.component.html',
    styleUrls: ['./easysuite-password.component.css']
})
export class EasysuitePasswordComponent implements OnInit {
    @Input() field: Field;
    @Input() fieldKey: string;
    @Input() formGroup: UntypedFormGroup

    showPassword: boolean = false;
    showToggleButton = false;
    private hasFocusBeenTriggered = false;


    constructor() { }

    ngOnInit(): void {
    }

    onInputFocus() {
        if (!this.hasFocusBeenTriggered) {
            this.hasFocusBeenTriggered = true;
            
            // Clear the password field value on first focus
            this.formGroup.get(this.fieldKey)?.setValue('');
            
            // Show the toggle button
            this.showToggleButton = true;
        }
    }
    
    togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    

}
